import { Component, OnInit, Input } from "@angular/core";
import { FormGroup } from '@angular/forms';
import { AdesaoService } from "src/app/services/adesao.service";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";


@Component({
    selector: "app-adesao-contribuicao",
    templateUrl: "./adesao-contribuicao.component.html",
    styleUrls: ["./adesao-contribuicao.component.css"],
    imports: [FormsModule, ReactiveFormsModule, CommonModule]
})
export class AdesaoContribuicaoComponent implements OnInit {

  contribuicaoMinima: number = 50.00;
  menorQueCtbMinima: boolean = false;
  idadeapos:boolean = false;
  msgErro:string = "";
  tiponedisabled: any = true;
  valor_primeiro_aporte = 50.00;
  dataNasc: Date;
  idade: number;

  userbirth: any = {
    tab: "five",
  };

  data: any = this.userbirth;

  @Input() parentForm: FormGroup;

  public constructor(private adesao: AdesaoService) {
    
  }

  ngOnInit() {

    // retirado para teste da gbp
    //this.buscarValorMinimoContribuicao();
    
  }


  setDataNasc(dataNasc: Date){
    this.dataNasc = dataNasc;    
  }

  buscarValorMinimoContribuicao(){
    this.adesao.buscarValorMinimoContribuicao()
    .subscribe(
      (res: number)=>{
        this.contribuicaoMinima = res;
      }
    )
  }

  onChangeInput(valormensal: any): void {

    const valor = Number(
      valormensal
        .replace(/R\$/g, "")
        .replace(/\./g, "")
        .replace(/\,00/g, "")
    );
   
    if (valor >= this.contribuicaoMinima && valor <= 10000) {

      const formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2
      });

      this.menorQueCtbMinima = false;
      this.parentForm.get("contribuicao.vlrCtb").setValue(formatter.format(valor));
      this.parentForm.get("contribuicao.vlrCtbRange").setValue(valor);

    } 
    else {
      this.parentForm.get("contribuicao.vlrCtb").setValue(null)
      this.menorQueCtbMinima = true;
    }    
  }

  onChangeInputPrimeiroAporte(valorprimeiroaporte: any): void {

    const valor_primeiro_aporte = Number(
      valorprimeiroaporte
        .replace(/R\$/g, "")
        .replace(/\./g, "")
        .replace(/\,00/g, "")
    );
   
   
    // if (valor_primeiro_aporte >= this.contribuicaoMinima && valor_primeiro_aporte <= 10000) {
    if (valor_primeiro_aporte >= this.contribuicaoMinima) {
      const formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2
      });
      this.menorQueCtbMinima = false;
      this.parentForm.get("contribuicao.vlrPrimeiroAporteCtb").setValue(formatter.format(valor_primeiro_aporte));
      this.parentForm.get("contribuicao.vlrPrimeiroAporteCtbRange").setValue(valor_primeiro_aporte);

    } 
    else {
        this.menorQueCtbMinima = true;
    }    
  }

  onChangeInputIdade(valoridade: any): void {
       
    let dtaPart = new Date(this.dataNasc); 
    let dtaAtual = new Date();

    let dataDif = Math.floor((dtaAtual.getTime() - dtaPart.getTime()) / (1000 * 60 * 60 * 24 * 365.25));

    if(dataDif >= 18 || Number(valoridade) >= 18){
      if (Number(valoridade) <= 99 && Number(valoridade) >= Number(dataDif)) {
        this.idadeapos = false;
        this.parentForm.get("contribuicao.idadeApos").setValue(valoridade);
        this.parentForm.get("contribuicao.idadeAposRange").setValue(Number(valoridade));
        this.msgErro = "";
      } else {
        this.idadeapos = true; 
        this.parentForm.get("contribuicao.idadeAposRange").setValue(null);
        'this.msgErro = " A idade mínima deve ser maior ou igual a sua idade atual";'
               
      }
    }else{
      this.idadeapos = true; 
      this.parentForm.get("contribuicao.idadeAposRange").setValue(null);
      'this.msgErro = "Para participantes menores de idade, a idade mínima é de 18 anos";'
    }
    
  }

  openOneModal() {
    this.tiponedisabled = false;    
  }

  closeOneModal() {
    this.tiponedisabled = true;
  }
 
}
